import {LocalType} from "app/types/common";

export const LANGS = ['hu', "en", "es", "fr", "ru", "pt", "id", "de", "ko", "tr", "zh", "vi", "ja"];


export const loadLocaleData = (locale: string) => {
    switch (locale) {
        case LocalType.En:
            return import("app/locales/en.json");
        case LocalType.Fr:
            return import("app/locales/fr.json");
        case LocalType.Zh:
            return import("app/locales/zh_CN.json");
        case LocalType.Es:
            return import("app/locales/es.json");
        case LocalType.Pt:
            return import("app/locales/pt.json");
        case LocalType.Ko:
            return import("app/locales/ko.json");
        case LocalType.Ja:
            return import("app/locales/ja.json");
        case LocalType.De:
            return import("app/locales/de.json");
        case LocalType.Hu:
            return import("app/locales/hu.json");
        case LocalType.Tr:
            return import("app/locales/tr.json");
        case LocalType.Ru:
            return import("app/locales/ru.json");
        case LocalType.Vi:
            return import("app/locales/vi.json");

        default:
            return import("app/locales/en.json");
    }
};

export function extractLocaleFromUrl(request: Request): string {
  try {
    const url = new URL(request.url);
    const pathname = url.pathname; // например, "/en/affiliate"
    const segments = pathname.split("/").filter(Boolean); // ["en", "affiliate"]

    const firstSegment = segments[0];
    if (firstSegment && LANGS.includes(firstSegment)) {
      return firstSegment;
    }
  } catch (e) {
    // игнорируем ошибки URL
  }

  return "en"; // дефолт
}
